import Popup from '../../UiKit/Elements/Popup/Popup';
import GeoControlSearch from '../../GeoControl/GeoControlSearch/GeoControlSearch';
import { geoControlFocusMobileInput } from '../../GeoControl/focusHelper';
import { NavigationGeoConfirmation } from '../NavigationGeoConfirmation/NavigationGeoConfirmation';

const action = '/api/autocomplete-city';

export const initNavigationCitySelect = (tag = 'navigation-city-select') => {
  const root = document.querySelector(`#${tag}`)
  if (!root) return;
  const control = root.querySelector(`[data-uipopup-trigger="${tag}"]`);
  const input = control.querySelector('input');
  const dropdown = root.querySelector(`[data-uipopup-for="${tag}"]`);
  const defaultList = dropdown.querySelector('[data-list="default"]');
  const resultsList = dropdown.querySelector('[data-list="results"]');
  const mobileInput = dropdown.querySelector('[data-search="field"]');
  const showButton = root.querySelector('[data-show-button]');

  new GeoControlSearch({
    defaultList,
    resultsList,
    action,
    input,
    parent: control,
    onBlur: () => {
      input.value = input.getAttribute('data-current-geo');
    },
  });

  new GeoControlSearch({
    defaultList,
    resultsList,
    action,
    input: mobileInput,
    parent: mobileInput.parentNode,
    onOpenDefaultList: () => {
      if (!showButton) return;
      showButton.classList.remove('hidden');
    },
    onOpenResultsList: () => {
      if (!showButton) return;
      showButton.classList.add('hidden');
    }
  });

  const popup = new Popup(tag, {
    onOpen: () => {
      geoControlFocusMobileInput(mobileInput, input);
    },
    closeOnTriggerClick: false,
  });

  if (window.userGeolocation) {
    new NavigationGeoConfirmation(popup);
  }
};
